import { useEffect, useRef, useState } from 'react'
import { initializeServices } from '@/app/bootstrap'
import { pbClient } from '@/services/pbClient'

export function useAppSession() {
  const [authVersion, setAuthVersion] = useState(0)
  const [sessionNotice, setSessionNotice] = useState('')
  const initializedServicesForUserRef = useRef<string | null>(null)

  const isAuthed = pbClient.isAuthenticated()
  const authUser = pbClient.getAuthUser()

  useEffect(() => {
    const unsubscribe = pbClient.subscribeAuthChange(() => {
      setAuthVersion((prev) => prev + 1)
    })

    return unsubscribe
  }, [])

  useEffect(() => {
    const handleExpired = (event: Event) => {
      const customEvent = event as CustomEvent<{ reason?: string }>
      const reason = customEvent.detail?.reason || 'session-expired'
      setSessionNotice(`Session expired (${reason}). Please sign in again.`)
    }

    window.addEventListener('clarix:session-expired', handleExpired as EventListener)

    return () => {
      window.removeEventListener('clarix:session-expired', handleExpired as EventListener)
    }
  }, [])

  useEffect(() => {
    if (!isAuthed || !authUser?.id) {
      initializedServicesForUserRef.current = null
      return
    }

    if (initializedServicesForUserRef.current === authUser.id) return

    initializedServicesForUserRef.current = authUser.id

    initializeServices(authUser.id).catch((err) => {
      initializedServicesForUserRef.current = null
      console.error('Failed to initialize services for user:', err)
    })
  }, [isAuthed, authUser?.id])

  function clearSessionNotice(): void {
    setSessionNotice('')
  }

  return {
    authVersion,
    isAuthed,
    authUser,
    sessionNotice,
    clearSessionNotice,
  }
}
